import { useEffect } from "react";

// Renders a JSON-LD <script> in <head> while the component is mounted.
// Cleans up on unmount so route changes don't pile up duplicate schema blocks.
export default function useJsonLd(schema, key) {
  useEffect(() => {
    if (!schema) return undefined;
    const id = `jsonld-${key || "page"}`;
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [JSON.stringify(schema), key]);
}
